// i18n para strings hardcodeados extraídos de:
//   - components/liqmap/LiqMapPage.jsx (tooltips de S/R engine)
//   - components/liqmap/SrTopLevelsDrawer.jsx (title attribute)
//   - components/SharePost.jsx (modal de compartir)
// Introducido en la migración DE + ZH-CN de Feb 2026 para eliminar
// deuda técnica de strings hardcodeados en ES.

const DICT = {
  es: {
    level_strength: "Fuerza del nivel",
    level_strength_desc: "score compuesto 0-100 combinando éxito histórico (40%), nº de toques (25%), recencia del último toque (20%) y proximidad al precio (15%).",
    confirmed_by_liq: "Confirmado por liquidaciones",
    confirmed_by_liq_desc: "el nivel coincide (±1%) con un cluster del heatmap. Doble validación técnica + liquidez.",
    real_liq_validated: "Liqs reales validadas",
    share_this_analysis: "Comparte este análisis",
    share_image_spec: "Imagen 1080×1080 con foto, texto, autor y marca de agua RE₿EL.",
    share_generating_image: "Generando imagen…",
    sr_levels_evaluated: "niveles evaluados",
    sr_coins_label: "monedas",
    menu_monetiza: "Monetiza",
    menu_listas: "Listas",
    share_on_x: "Compartir en X",
    zone_quality: "calidad de zona",
    real_liqs_recorded: "liqs reales registradas",
    quality_validated_by_hist_liq: "calidad validada por liquidez histórica",
  },
  en: {
    level_strength: "Level strength",
    level_strength_desc: "composite score 0-100 combining historical success (40%), touch count (25%), recency of last touch (20%), and price proximity (15%).",
    confirmed_by_liq: "Confirmed by liquidations",
    confirmed_by_liq_desc: "the level matches (±1%) a heatmap cluster. Double validation: technical + liquidity.",
    real_liq_validated: "Real liqs validated",
    share_this_analysis: "Share this analysis",
    share_image_spec: "1080×1080 image with photo, text, author and RE₿EL watermark.",
    share_generating_image: "Generating image…",
    sr_levels_evaluated: "levels evaluated",
    sr_coins_label: "coins",
    menu_monetiza: "Monetize",
    menu_listas: "Lists",
    share_on_x: "Share on X",
    zone_quality: "zone quality",
    real_liqs_recorded: "real liqs recorded",
    quality_validated_by_hist_liq: "quality validated by historical liquidity",
  },
  sk: {
    level_strength: "Sila úrovne",
    level_strength_desc: "kompozitné skóre 0-100 kombinujúce historickú úspešnosť (40%), počet dotykov (25%), recentnosť posledného dotyku (20%) a blízkosť k cene (15%).",
    confirmed_by_liq: "Potvrdené likvidáciami",
    confirmed_by_liq_desc: "úroveň sa zhoduje (±1%) s clusterom z heatmapy. Dvojitá validácia technická + likvidita.",
    real_liq_validated: "Reálne likvidácie potvrdené",
    share_this_analysis: "Zdieľať túto analýzu",
    share_image_spec: "Obrázok 1080×1080 s fotkou, textom, autorom a vodoznakom RE₿EL.",
    share_generating_image: "Generujem obrázok…",
    sr_levels_evaluated: "úrovní vyhodnotených",
    sr_coins_label: "mien",
    menu_monetiza: "Monetizovať",
    menu_listas: "Zoznamy",
    share_on_x: "Zdieľať na X",
    zone_quality: "kvalita zóny",
    real_liqs_recorded: "reálne likvidácie zaznamenané",
    quality_validated_by_hist_liq: "kvalita overená historickou likviditou",
  },
  de: {
    level_strength: "Stärke des Niveaus",
    level_strength_desc: "zusammengesetzter Score 0-100, der historischen Erfolg (40%), Anzahl der Berührungen (25%), Aktualität der letzten Berührung (20%) und Nähe zum Preis (15%) kombiniert.",
    confirmed_by_liq: "Durch Liquidationen bestätigt",
    confirmed_by_liq_desc: "das Niveau stimmt (±1%) mit einem Cluster der Heatmap überein. Doppelte Validierung technisch + Liquidität.",
    real_liq_validated: "Echte Liqs validiert",
    share_this_analysis: "Diese Analyse teilen",
    share_image_spec: "Bild 1080×1080 mit Foto, Text, Autor und RE₿EL-Wasserzeichen.",
    share_generating_image: "Bild wird generiert…",
    sr_levels_evaluated: "Level ausgewertet",
    sr_coins_label: "Coins",
    menu_monetiza: "Monetarisieren",
    menu_listas: "Listen",
    share_on_x: "Auf X teilen",
    zone_quality: "Zonenqualität",
    real_liqs_recorded: "echte Liqs erfasst",
    quality_validated_by_hist_liq: "Qualität validiert durch historische Liquidität",
  },
  "zh-CN": {
    level_strength: "水平强度",
    level_strength_desc: "综合评分0-100，结合历史成功率（40%）、触及次数（25%）、最近触及时间（20%）和价格接近度（15%）。",
    confirmed_by_liq: "强制平仓确认",
    confirmed_by_liq_desc: "该水平与热力图Cluster（±1%）一致。技术 + 流动性双重验证。",
    real_liq_validated: "已验证的真实强制平仓",
    share_this_analysis: "分享此分析",
    share_image_spec: "1080×1080图片，包含照片、文本、作者和RE₿EL水印。",
    share_generating_image: "正在生成图片…",
    sr_levels_evaluated: "已评估水平",
    sr_coins_label: "币种",
    menu_monetiza: "变现",
    menu_listas: "列表",
    share_on_x: "分享到X",
    zone_quality: "区域质量",
    real_liqs_recorded: "已记录真实强制平仓",
    quality_validated_by_hist_liq: "由历史流动性验证的质量",
  },
};

export const useHardcodedI18n = (lang) => DICT[lang] || DICT.es;
